import React, { useRef, useState } from 'react'
import styles from "../../../../Styles/ComponentStyles/MainPages/Member.module.scss"
import globalStyles from "../../../../Styles/global.module.scss"

import Grid from '@mui/material/Grid2';
import { Avatar, Checkbox, CircularProgress, FormControlLabel, Menu, MenuItem, Typography } from '@mui/material';
import GlobalTextfield from '../../../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import GlobalSymbols from '../../../../Utils/Layout/GlobalSymbols/GlobalSymbols';
import Icons from '../../../../Utils/Layout/Icons/Icons';
import { Global } from '@emotion/react';
import GlobalButton from '../../../../Utils/Layout/GlobalButton/GlobalButton';

function AcrylicNewMemberDialog(props: any) {

    const imageInputRef = useRef<HTMLInputElement>(null);
    const [isUploading, setIsUploading] = useState<boolean>(false);


    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12 }} sx={{ margin: '20px 0px' }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }}>
                            <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV13}`}>
                                Add New Member
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Grid container sx={{ justifyContent: 'space-between' }}>
                                <Grid size={{ xs: 2 }} className={styles.atAvtarItem}>
                                    <Grid container>
                                        <Avatar
                                            // src={userDetails?.profileImage ? userDetails?.profileImage : ""}
                                            sx={{
                                                width: "100%",
                                                height: "100px"
                                            }}
                                        />
                                        {isUploading &&
                                            <div
                                                style={{
                                                    position: "absolute", zIndex: 2, top: "30px", left: "30px"
                                                }}
                                            >
                                                <CircularProgress />
                                            </div>
                                        }
                                        <div
                                            className={`${styles.profileEditImageItem}`}
                                        // onClick={handleProfileMenuClick}
                                        >
                                            <Icons iconName="profileEditIcon" iconHeight="28px" iconWidth="28px" />
                                        </div>
                                        {/* <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleProfileMenuClose}
                                        >
                                            <MenuItem
                                            // onClick={handleProfileEdit}
                                            >
                                                Change Profile Picture
                                            </MenuItem>

                                            <MenuItem
                                            // onClick={handleProfileDelete}
                                            >
                                                Remove Profile Photo
                                            </MenuItem>
                                        </Menu> */}
                                        <input
                                            id="avatar"
                                            accept="image/*"
                                            type="file"
                                            ref={imageInputRef}
                                            style={{ display: "none" }}
                                        // onChange={handleImageUpload}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid size={{ xs: 9 }}>
                                    <Grid container sx={{ justifyContent: 'space-between', gap: "10px", rowGap: '25px' }}>
                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        First Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter First Name'
                                                        autoComplete='off'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Last Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Last Name'
                                                        autoComplete='off'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Email <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Email'
                                                        autoComplete='off'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Member Designation Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Designation Name'
                                                        autoComplete='off'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Phone Number <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Phone Number'
                                                        autoComplete='off'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.memberuserFieldItem}`}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Set as Default <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                size="small"
                                                                checked={true}
                                                                icon={<Icons iconName="checkbox" iconWidth="20px" iconHeight="20px" />}
                                                                checkedIcon={<Icons iconName="checkedIcon" iconWidth="20px" iconHeight="20px" />}
                                                                sx={{ padding: "0px 8px" }}
                                                            />
                                                        }
                                                        label=""
                                                        className={styles.signinCheckboxLabel}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid size={{ xs: 12 }}>
                                            <Grid container>
                                                <Grid size={{ xs: 12 }} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Description <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12 }}>
                                                    <GlobalTextfield
                                                        fullWidth={true}
                                                        size='small'
                                                        placeholder='Enter Description'
                                                        autoComplete='off'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: '40px 0px 0px' }}>
                            <Grid container sx={{ justifyContent: 'center', gap: '25px', alignItems: 'center' }}>
                                <Grid className={styles.atDialogBtnItem}>
                                    <GlobalButton
                                        value='Cancel'
                                        size='medium'
                                        fullWidth={true}
                                        variant='outlined'
                                        className={globalStyles.globalButtonOutlinedStyleV1}
                                    />
                                </Grid>
                                <Grid className={styles.atDialogBtnItem}>
                                    <GlobalButton
                                        value='Save'
                                        size='medium'
                                        fullWidth={true}
                                        variant='contained'
                                        className={globalStyles.globleButtonStyleV1}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AcrylicNewMemberDialog